/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fw_Bench_TitleInputs */

const en_fw_bench_title = /** @type {(inputs: Fw_Bench_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Public benchmark`)
};

const id_fw_bench_title = /** @type {(inputs: Fw_Bench_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benchmark publik`)
};

/**
* | output |
* | --- |
* | "Public benchmark" |
*
* @param {Fw_Bench_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const fw_bench_title = /** @type {((inputs?: Fw_Bench_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fw_Bench_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_fw_bench_title(inputs)
	return en_fw_bench_title(inputs)
});